
<div class="block">
    <div class="required">
        <label>{{ 'Components.EnterOldPassword.PasswordHeaderText' | translate }}</label>
    </div>

    <input class="form-control"
           name="OldPassword"
           type="password"
           [(ngModel)]="oldPasswordValue">

</div>

<div class="block"
     [style.display]="showCaptcha ? 'block' : 'none'">

    <app-captcha #captchaComponent></app-captcha>
    <input id="captchaCode"
           name="captchaCode"
           [(ngModel)]="captchaCode"
           class="form-control"
           autocomplete="off"
           placeholder="{{ 'Common.CaptchaText' | translate }}"
           type="text">
</div>

<div class="btn-group">
    <button class="btn btn-primary"
            type="submit"
            (click)="submitButtonClick($event)">
        {{submitButtonText}}
    </button>
</div>

<span *ngIf="errorText"
      class="text-danger error">
    {{errorText}}
</span>
